<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawerVisible"
      app
    >
      <v-list>
        <v-list-item :to="{ name: 'players' }">
          <v-list-item-title>
            Players
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-headphones
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'streams' }">
          <v-list-item-title>
            Streams
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-headphones
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'radios' }">
          <v-list-item-title>
            Radios
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              far fa-play-circle
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'musicLibrary' }">
          <v-list-item-title>
            Library
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-music
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'playlists' }">
          <v-list-item-title>
            Playlists
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              far fa-list-alt
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'marketingCampaigns' }">
          <v-list-item-title>
            Marketing
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-poll
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'clients' }">
          <v-list-item-title>
            Clients
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-hotel
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'users' }">
          <v-list-item-title>
            Users
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-user
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item :to="{ name: 'blog' }">
          <v-list-item-title>
            Blog
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon small>
              fas fa-rss
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="user"
      app
      color="dark-gradient"
      dark
      elevation="20"
      :hide-on-scroll="$vuetify.breakpoint.xsOnly"
      :class="{ 'd-flex justify-center': !$vuetify.breakpoint.xsOnly }"
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.xsOnly && $can('manage-all')"
        class="mr-4"
        @click="drawerVisible = !drawerVisible"
      />
      <img
        src="@/assets/logo_badge.png"
        style="height: 35px"
        class="mr-5"
      >
      <v-toolbar-title class="font-weight-medium subtitle-1 mr-5 hidden-xs-only">
        Admin Console
      </v-toolbar-title>
      <v-toolbar-items v-if="!$vuetify.breakpoint.xsOnly">
        <v-btn
          text
          :to="{ name: 'players' }"
        >
          <v-icon
            left
            small
          >
            fas fa-headphones
          </v-icon>
          Players
        </v-btn>
        <v-btn
          text
          :to="{ name: 'streams' }"
        >
          <v-icon
            left
            small
          >
            fas fa-headphones
          </v-icon>
          Streams
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'radios' }"
        >
          <v-icon
            left
            small
          >
            far fa-play-circle
          </v-icon>
          Radios
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'musicLibrary' }"
        >
          <v-icon
            left
            small
          >
            fas fa-music
          </v-icon>
          Library
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'playlists' }"
        >
          <v-icon
            left
            small
          >
            far fa-list-alt
          </v-icon>
          Playlists
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'marketingCampaigns' }"
        >
          <v-icon
            left
            small
          >
            fas fa-poll
          </v-icon>
          Marketing
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'clients' }"
        >
          <v-icon
            left
            small
          >
            fas fa-hotel
          </v-icon>
          Clients
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'users' }"
        >
          <v-icon
            left
            small
          >
            fas fa-user
          </v-icon>
          Users
        </v-btn>
        <v-btn
          v-if="$can('manage-all')"
          text
          :to="{ name: 'blog' }"
        >
          <v-icon
            left
            small
          >
            fas fa-rss
          </v-icon>
          Blog
        </v-btn>
      </v-toolbar-items>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          icon
          @click="signOut()"
        >
          <v-icon small>
            fas fa-sign-out-alt
          </v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <v-main
      v-if="userChecked"
      class="mt-xl-6"
    >
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>

    <v-snackbar
      v-model="snackbarVisible"
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          outlined
          small
          v-bind="attrs"
          @click="snackbarVisible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      drawerVisible: false
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    userChecked() {
      return this.$store.state.auth.checked
    },
    snackbar() {
      return this.$store.state.alert
    },
    snackbarVisible: {
      get: function () {
        return this.$store.state.alert.visible
      },
      set: function (value) {
        this.$store.dispatch('alert', { visible: value })
      }
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout')

      this.$router.push({ name: 'login' })
    }
  }
}
</script>
